// 折线图类型
export const CHART_TYPE_POLYLINE = 'polyline';
// 点图类型
export const CHART_TYPE_POINT = 'point';
// 柱状图类型
export const CHART_TYPE_HISTOGRAM = 'histogram';
// 单色面积图类型（无折线）
export const CHART_TYPE_FILL_AREA = 'fill-area';
// 画多色面积图（无折线）
export const CHART_TYPE_MULTI_COLOR_FILL_AREA = 'multi-color-fill-area';
// 面积图类型
export const CHART_TYPE_AREA = 'area';

export const CHART_TYPE_UP_DOWN_HISTOGRAM = 'up_down_histogram';
export const CHART_TYPE_PLURALITY_RECT = 'plurality_rect';
